import * as styles from "./BreadcrumbLink.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { useRender } from "@base-ui/react/use-render";
import { Icon } from "@frontend/components/atoms/Icon";

import type { BreadcrumbLinkProps } from "./Breadcrumb.types";

export function BreadcrumbLink({
  href,
  active,
  disabled,
  icon,
  children,
  className,
  render,
}: BreadcrumbLinkProps): JSX.Element {
  const content = (
    <>
      {icon && <Icon name={icon} size="sm" />}
      {children}
    </>
  );

  const link = useRender({
    defaultTagName: "a",
    render,
    props: {
      "data-slot": "breadcrumb-link",
      href: disabled ? undefined : href,
      "aria-disabled": disabled,
      className: clsx(styles.link, disabled && styles.disabled, className),
      children: content,
    },
  });

  if (active) {
    return (
      <span
        data-slot="breadcrumb-link"
        data-active
        aria-current="page"
        className={clsx(styles.link, styles.active, className)}
      >
        {content}
      </span>
    );
  }

  return link;
}
